var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-cascader", {
    ref: _vm.refs,
    attrs: {
      placeholder: _vm.placeholder,
      "popper-class": _vm.refs,
      disabled: _vm.disabled,
      options: _vm.datas,
      "collapse-tags": "",
      props: _vm.props,
      filterable: "",
      "show-all-levels": _vm.showAllLevels,
      clearable: _vm.clearable
    },
    on: {
      "visible-change": _vm.visibleChange,
      "expand-change": _vm.visibleChange,
      change: _vm.checkChange
    },
    model: {
      value: _vm.ids,
      callback: function($$v) {
        _vm.ids = $$v
      },
      expression: "ids"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05e3c197", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e3c197","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MajorCascader.vue
// module id = 600
// module chunks = 14